module.exports = __webpack_public_path__ + "img/picto2.32f69a69.svg";